import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crg-directions',
  templateUrl: './directions.component.html',
  styleUrls: ['./directions.component.scss']
})
export class DirectionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
